import { FC, useContext } from 'react'
import { Flex, Grid } from '@/components/atoms/Grid'
import styled, { withTheme } from 'styled-components'
import TopManufacturerMarquee from '@/components/organisms/topManufacturerMarquee'
import {
  HomeBanner,
  Manufacturer,
  Campaign as CampaignModel,
  TopManufacturerDepartment
} from '@/network/graphql.g'
import MainBannerSlider from './mainBannerSlider'

import HomePageCampaigns from './homePageCampaigns'
import { StoreContext } from '@/providers/storeProvider'
import { useAsset } from '@/providers/assetsProvider'
import useTopManufacturerDepartment from 'hooks/useTopManufacturerDepartment'

export type TopManufacturersByDepartment = Record<
  TopManufacturerDepartment,
  Manufacturer[]
>

type HomeBannersProps = {
  bannerElements: HomeBanner[]
  topManufacturersByDepartment: TopManufacturersByDepartment
  campaigns: CampaignModel[]
} & Rest

const HomePageBanners: FC<HomeBannersProps> = ({
  bannerElements,
  topManufacturersByDepartment,
  campaigns,
  ...rest
}) => {
  const { isFrogies } = useContext(StoreContext)
  const { isRsAndBaMarket } = useAsset()
  const department = useTopManufacturerDepartment()
  const withLogo = (manufacturers?: Manufacturer[]): Manufacturer[] =>
    (manufacturers ?? []).filter((manufacturer) => manufacturer?.image != null)
  const departmentManufacturers = withLogo(
    topManufacturersByDepartment[department]
  )
  const topManufacturers = departmentManufacturers.length
    ? departmentManufacturers
    : withLogo(topManufacturersByDepartment[TopManufacturerDepartment.All])

  return (
    <StyledFlex {...rest} data-testid="homepageBanners">
      {!isRsAndBaMarket ? (
        <MainBannerSlider
          bannerElements={bannerElements}
          isHomePageBanner={true}
        />
      ) : null}

      {!isFrogies ? (
        <TopManufacturerMarquee width="100%" manufacturers={topManufacturers} />
      ) : null}

      <BannersWrapper mt={{ desktop: '20px', tablet: '20px', mobile: '12px' }}>
        <Grid
          mt={16}
          gridTemplateColumns={{
            desktop: '1fr 1fr 1fr',
            tablet: '1fr 1fr',
            mobile: '1fr'
          }}
          gridRowGap={20}
          gridColumnGap={18}
        >
          {campaigns.map((item, idx) => (
            <HomePageCampaigns key={idx} campaign={item} />
          ))}
        </Grid>
      </BannersWrapper>
    </StyledFlex>
  )
}

export default withTheme(HomePageBanners)

const StyledFlex = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const BannersWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  width: 100%;
`
